// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__39zYR","tableContainer":"Table_tableContainer__28RRH","table":"Table_table__2zipq","paginationWrapper":"Table_paginationWrapper__zPVQ1"};